<template>

    <div>

        <el-dialog
                title="供应商列表"
                :visible.sync="visible"
                width="80%"
                @close="close">

            <el-table :data="tableData"
                      ref="singleTable"
                      highlight-current-row
                      @current-change="handleCurrentRowChange"
                      style="width: 100%">
                <el-table-column prop="company" label="公司编号">

                    <template slot="header" slot-scope="scope">
                        公司编号<br>
                        <el-input size="mini" v-model="searchInfo.company"
                                  class="width70"></el-input>
                    </template>

                </el-table-column>

                <el-table-column prop="name" label="公司名称">

                    <template slot="header" slot-scope="scope">
                        公司名称<br>
                        <el-input size="mini" v-model="searchInfo.name"
                                  class="width70"></el-input>
                    </template>

                </el-table-column>
            </el-table>

            <el-pagination align="right"
                           @current-change="handleCurrentChange"
                           @size-change="handleSizeChange"
                           :current-page="currentPage"
                           :page-sizes="pageSizes" :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>

            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelFunc">取 消</el-button>
                <el-button type="primary" @click="confirmFunc">确 定</el-button>
            </span>
        </el-dialog>

        <!-- <div style="margin-top: 20px">
           <el-button @click="setCurrent(tableData[1])">确定</el-button>
            <el-button @click="setCurrent()">取消</el-button>
        </div>-->

    </div>

</template>

<script>

    import {debounce} from '../../util'
    import {athubAxios} from '../../util'
    import CompanyServer from '../../api/company/index'

    export default {

        name: "company_dialog",

        data() {
            return {

                visible: this.dialogCompanyVisible,

                currentRow: null,

                currentPage: 1,
                pageSize: 10,
                total: 0,
                pageSizes: [10, 25, 50, 100],

                searchInfo: {
                    company: '',
                    name: '',
                },

                tableData: [],
            }
        },

        props: ['dialogCompanyVisible'],

        methods: {

            handleCurrentChange(val) {
                this.currentPage = val
                this.queryTable();
            },

            handleSizeChange(val) {
                this.pageSize = val;
                this.queryTable();
            },

            handleCurrentRowChange(val) {
                this.currentRow = val;
            },

            queryTable() {

                let aoDataArr = [
                    {
                        name: 'iDisplayStart',
                        value: this.currentPage * this.pageSize - 1,
                    },
                    {
                        name: 'iDisplayLength',
                        value: this.pageSize
                    }
                ];
                let params = {
                    aoData: JSON.stringify(aoDataArr),
                    company: this.searchInfo.company,
                    name: this.searchInfo.name
                };
                CompanyServer.company.page(params).then(responseBody => {
                    this.tableData = responseBody.aaData;
                    this.total = responseBody.iTotalRecords;
                });

            },

            close(){
                this.$emit('update:dialogCompanyVisible', false);
            },

            cancelFunc() {
                this.close();
            },

            confirmFunc() {

                this.$emit('afterCompanyDialogFunc', this.currentRow);

                this.close();
            },

        },

        watch: {

            dialogCompanyVisible: {
                handler: function (newVal, oldVal) {
                    this.visible = newVal;
                }
            },

            searchInfo: {
                immediate: true,
                deep: true,
                handler: debounce(function (newVal, oldVal) {
                    this.currentPage = 1;
                    this.queryTable();
                }, 500)
            },

        },

        mounted() {
            this.queryTable();
        }

    }


</script>
